import { Stack } from 'expo-router';

import { getScreenTitleHeader } from '../../../../components/get-screen-title-header';

export default function GiftCardsLayout() {
  return (
    <Stack>
      <Stack.Screen
        name="index"
        options={{
          header: getScreenTitleHeader(),
          title: 'Gift Cards',
        }}
      />
    </Stack>
  );
}
